import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Validation from "../../../commonComponents/Validation";
import {saveReportPost} from "../../../services/apiPosts";
import report from "../../../assets/img/report.svg";
import ResponsePopup from "../../../commonComponents/responseSucessPopup";

const ReportPost = (props)=>{
const Group = require("../../../assets/img/report.svg");
const[formData,setFormData]=useState({
  message:""
});
const[isSucess,SetSucess]=useState(false);
const[ResponseMessage,SetResponseMessage]=useState("");
const userData = JSON.parse(localStorage.getItem('userData'));
 const [errors, setErrors] = useState(false);
 const validateForm = ()=>{
  const newErrors = {};
  if(!formData.message) newErrors.message=true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}
const handleChange=async(event)=>{
  const { name, value } = event.target;
      if (formData[name] !== value) {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
      }
        setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
    }));
}
const closePopup =() =>{
  props.HideReport();
  
}

const ReportPost = async(event)=>{
  event.preventDefault();
 if (!validateForm()) return;
  formData.userid = userData._id;
  formData.postid = props.reportId;
 let response = await saveReportPost(formData);
  if(response.status === true){
    props.HideReport();
     formData.message = ""; 
      SetSucess(true);
      SetResponseMessage("Your post has been reported!");
    
    
  }
   
}


return(
<div>
      <Modal show={props.showReport} onHide={props.HideReport}
         dialogClassName="small-custom-modal modal-dialog-centered">
        <Modal.Header closeButton>
        <div className="popupheader">
        <div className="mod-bor-icon" >
              <img src={report} className="mod-icon"></img>
            </div>
            <div className="header">
              <div className="signuup">Report Post</div>
              <p className="Stronger">Help us keep the community safe.</p>
              
            </div>
          </div>
        </Modal.Header>
   
       <Modal.Body>
        <div>
          <p className="fov-text">Are you sure you want to report this post?</p>
          <div className="text-space">
                <textarea className="coment-box" id="message" name="message" rows="5" cols="40" placeholder="Enter The Reason" value={formData.message} onChange={handleChange}></textarea>
              </div>
               {errors.message && (
                                <Validation message={'Please enter the reason'}/>
                            )}
          </div>
       
        
        </Modal.Body>
    
      <Modal.Footer className="full-w" >
                             <button type="button" className="cancel-btn"  onClick={() => {
                  closePopup();
                }}
              >
                No</button>
                              <button className="next-btn" onClick={(e)=>ReportPost(e)}> {" "} Yes{" "}</button>
                    </Modal.Footer>
       
      
      </Modal>
       {isSucess && (<ResponsePopup 
                      isSucess={isSucess} 
                      CancelPopup={() => { 
                       SetSucess(false);
                      }} 
                      message={ResponseMessage}
                    />)}
    </div>
);
  

};
export default ReportPost;